import React from 'react';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'Experience', id: 'experience' },
    { name: 'Gallery', id: 'gallery' },
    { name: 'Videos', id: 'videos' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="text-2xl font-bold mb-4">
              <span className="text-sky-400">Hristina</span>
              <span className="text-white"> Vassileva</span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-md">
              Elite figure skating coach and choreographer with international competition experience. Dedicated to developing champions through expert technique training and artistic expression.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/hristina.vassileva"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-sky-600 p-3 rounded-lg transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/vassilevahristina/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-sky-600 p-3 rounded-lg transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="hover:text-sky-400 transition-colors duration-300"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">
              Contact
            </h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:hr_vassileva@yahoo.com"
                  className="flex items-center space-x-3 hover:text-sky-400 transition-colors duration-300"
                >
                  <Mail className="w-5 h-5" />
                  <span className="text-sm">hr_vassileva@yahoo.com</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+359878841332"
                  className="flex items-center space-x-3 hover:text-sky-400 transition-colors duration-300"
                >
                  <Phone className="w-5 h-5" />
                  <span className="text-sm">+359 878 841 332</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400">
                <svg className="w-5 h-5 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-sm">Sofia, Bulgaria</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-slate-400">
              © {currentYear} Hristina Vassileva-Zhecheva. All rights reserved.
            </p>
            <p className="text-sm text-slate-400">
              Elite Figure Skating Coaching & Choreography
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;